import {Config} from 'app/config';

/**
 * Builds the animal-browser link for an animal code.
 *
 * @param animalCode Animal code displayed by the browser.
 * @returns A full browser URL for the animal.
 */
export const getAnimalBrowserLink = (animalCode: string): string => `${Config.url}/ProhlizecZvirat/Index/${animalCode}`;
